export type TextFieldProps = {
    handleOnChange : (e : any) => void
    label?: string
    icon?: any
    type?: string
    value?: string | number
    disabled?: boolean
    color?: string
    name?: string
    checked?: boolean
}

export enum InputTypes {
    Text = "text",
    Number = "number",
    Email = "email",
    Date = "date",
    Money = "money",
    Percent = "percent",
    Password = "password"
}


export type FormProps = {

    model: any,
    setModel: Function,
    setOpen?: Function,
    open?: Function
}

export interface FieldProps extends FormProps {
    required?: boolean
    placeholder?: string
    campoId: string,
    label?: string,
    onBlur?: any,
    type: InputTypes,
    children?: any,
    disabled?: boolean
    icon?: React.ReactNode
    onReset?: Function

}



export default FieldProps;
